import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { IqacSubHeadingRoutingModule } from './iqac-subheading-routing.module';
import { IqacsubheadingListComponent } from './iqacsubheading-list/iqacsubheading-list.component';
import { IqacsubheadingCreateComponent } from './iqacsubheading-create/iqacsubheading-create.component';

@NgModule({
  declarations: [IqacsubheadingListComponent, IqacsubheadingCreateComponent],
  imports: [
    CommonModule,
    IqacSubHeadingRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class IqacSubHeadingModule { }
